import { render, staticRenderFns } from "./mktNotification.vue?vue&type=template&id=85646082&"
import script from "./mktNotification.vue?vue&type=script&lang=js&"
export * from "./mktNotification.vue?vue&type=script&lang=js&"
import style0 from "./mktNotification.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports